var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container",style:('height: ' + _vm.height + 'px')},[(_vm.dataIsLoaded)?[_c('canvas',{attrs:{"id":_vm.canvasId}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }